import React, { useState } from "react";
import { Send, CheckCircle2, Loader2 } from "lucide-react";
import { toast } from "sonner";
import api from "../../../lib/api";

export default function Newsletter() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email) return;
    setLoading(true);
    try {
      const res = await api.post("/newsletter", { email, source: "footer-newsletter" });
      if (res.data?.already_subscribed) {
        toast.success("You're already subscribed — see you on Friday!");
      } else if (res.data?.email_sent) {
        toast.success("You're in! Check your inbox for your welcome email.");
      } else {
        toast.success("You're in! We'll be in touch soon.");
      }
      setEmail("");
      setDone(true);
      setTimeout(() => setDone(false), 4000);
    } catch (err) {
      toast.error("Could not subscribe — please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="w-full flex flex-col lg:flex-row items-start lg:items-center justify-between gap-6 py-8 border-t border-gray-200/50 mt-12">
      <div className="max-w-md">
        <h4 className="text-base font-bold text-gray-900 font-display">
          Stay Updated
        </h4>
        <p className="mt-1 text-sm text-gray-500">
          Subscribe to receive startup insights, AI product updates, funding news and feature releases.
        </p>
      </div>

      <form onSubmit={handleSubmit} className="w-full lg:w-auto flex flex-col sm:flex-row gap-3 min-w-[320px] sm:min-w-[420px]" data-testid="footer-newsletter-form">
        <div className="relative flex-1">
          <input
            type="email"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="Enter your email"
            className="w-full px-5 py-3 rounded-full bg-white border border-gray-200 focus:outline-none focus:border-[#7C3AED] focus:ring-4 focus:ring-[#7C3AED]/10 text-sm transition-all duration-300 placeholder:text-gray-400"
            data-testid="footer-newsletter-email"
          />
        </div>
        <button
          type="submit"
          disabled={loading}
          className="glow-button rounded-full px-6 py-3 text-sm font-semibold inline-flex items-center justify-center gap-2 disabled:opacity-75 h-[46px] shrink-0"
          data-testid="footer-newsletter-submit"
        >
          {loading ? (
            <Loader2 className="w-4 h-4 animate-spin" />
          ) : done ? (
            <>
              <CheckCircle2 className="w-4 h-4" />
              Subscribed
            </>
          ) : (
            <>
              Subscribe
              <Send className="w-3.5 h-3.5" />
            </>
          )}
        </button>
      </form>
    </div>
  );
}
